// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__3rylC","column":"styles_column__2qII3","titleWrap":"styles_titleWrap__9leUh","title":"styles_title__2uds-"};